import { requireSiteAdmission } from "@/features/game/data";
import { redirect } from "@tanstack/react-router";
import type { Schemas } from "@softmax/observatory-client/types";
import { buildHref } from "@softmax/web-addresses";
import { getActualViewer } from "@/data/viewer";

import { createPlayApi } from "./play-api";

export async function readPlayDestination({
  signal,
}: { signal?: AbortSignal | undefined } = {}) {
  await requireSiteAdmission({
    signal,
    href: buildHref({ name: "play" }),
    game: null,
  });

  if (!(await getActualViewer({ signal }))) {
    throw redirect({
      href: buildHref({
        name: "signIn",
        search: new URLSearchParams({
          redirect_url: buildHref({ name: "play" }),
        }),
      }),
      statusCode: 307,
    });
  }

  const destination = await createPlayApi({ signal }).get<
    Schemas["PlayDestination"] | null
  >({
    path: "/v2/play-destination",
  });

  if (!destination) return null;

  if (!destination.league.short_name)
    throw new Error(`Missing address for league ${destination.league.id}`);

  return buildHref({
    name: "game.play",
    game: destination.game_address,
    league: destination.league.short_name,
  });
}
